// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2b553d4f]:root{--color-brand:#e73389;--color-brand-dark:#af2769;--color-brand-light:#f29dc3;--color-brand-picker:#e73389;--color-headerBg:#0a3749;--color-headerTxt:#fff;--color-brandPlyr:#e73389;--color-brand-darkPlyr:#af2769;--color-brand-lightPlyr:#f29dc3;font-size:14px}.proximity-word[data-v-2b553d4f]{width:10rem}.proximity-seconds[data-v-2b553d4f],.timeframe-duration[data-v-2b553d4f]{width:6rem}", ""]);
// Exports
module.exports = exports;
